import React from "react";
import ReactExport from "react-data-export";
import { DialogContent } from "@material-ui/core";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

function StyledExcelExport(props) {
  return (
    <>
      <DialogContent>
        <div>
          <ExcelFile hideElement={true}>
            <ExcelSheet dataSet={props.data} name="Organization" />
          </ExcelFile>
        </div>
      </DialogContent>
    </>
  );
}

export default StyledExcelExport;
